export const CHOOSE_DATES = "Choose Dates";
export const CHECK_IN = "Check-in";
export const CHECK_OUT = "Check-out";
export const SEARCH_DATES = "Search Dates";
export const SELECT_DATES = "Select dates to view availability";
export const SELECT_DATES_ERROR = "Select new dates to view availability"
